// ============================================
// PageHeader Component
// Page header with section label, title, subtitle, and actions
// ============================================

import { ReactNode } from 'react';
import { cn } from '../../utils/cn';

// ============================================
// Types
// ============================================

interface PageHeaderProps {
  /** Main page title */
  title: string;
  /** Section label above title (e.g., "STOCK OVERVIEW") - uppercase blue text */
  sectionLabel?: string;
  
  /** Optional subtitle below title */
  subtitle?: string;
  /** Right-side action buttons/controls */
  actions?: ReactNode;
  /** Additional className for the container */
  className?: string;
}

// ============================================
// Component
// ============================================

export function PageHeader({
  title,
  sectionLabel,
  subtitle,
  actions,
  className,
}: PageHeaderProps) {
  return (
    <div className={cn('flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between', className)}>
      {/* Left side - Title section */}
      <div>
        <h1 className="text-[28px] font-extrabold text-[#191B23]">
          {title}
        </h1>
        {sectionLabel && (
          <p className="mb-1 text-xs font-bold uppercase tracking-[1.2px] text-primary-600">
            {sectionLabel}
          </p>
        )}
        
        {subtitle && (
          <p className="mt-0.5 text-xs font-bold uppercase tracking-[1.2px] text-primary-600">{subtitle}</p>
        )}
      </div>

      {/* Right side - Actions */}
      {/* `w-full sm:w-auto` + `min-w-0`: trên mobile hàng nút phải được phép chiếm
          trọn bề ngang rồi tự xuống dòng. Trước đây nó co theo flex nên nút cuối
          bị đẩy ra ngoài mép màn hình và không cách nào chạm tới. */}
      {actions && (
        <div className="flex w-full min-w-0 flex-wrap items-center gap-2 sm:w-auto sm:justify-end sm:gap-3">
          {actions}
        </div>
      )}
    </div>
  );
}
